import React, { useState } from "react";
import { Button, MenuItem, Select, TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AlertManager from "../../shared/Alert/Alert";
import classes from "../Rules/RulesPage.module.css";

const EMAIL_OPTIONS = [
  {
    value: "landedCostEmails",
    label: "Landed cost emails",
  },
  {
    value: "landedEscalationEmails",
    label: "Landed cost escalation emails",
  },
  {
    value: "dcEmails",
    label: "DC cost  emails",
  },
  {
    value: "dcEscalationEmails",
    label: "DC cost escalation emails",
  },
];

const RULE_OPTIONS = [
  { value: "landingRules", label: "Landing rules" },
  { value: "prioritizationRules", label: "Prioritization rules" },
  { value: "marginSetup", label: "Margin setup" },
];

const NAV_SECTIONS = [
  { key: "email", title: "Email intimation" },
  { key: "rules", title: "Rules configuration" },
];

const UserAssignment = () => {
  const [selectedEmailGroup, setSelectedEmailGroup] = useState(
    EMAIL_OPTIONS[0]?.value || ""
  );
  const [selectedRuleGroup, setSelectedRuleGroup] = useState(
    RULE_OPTIONS[0]?.value || ""
  );
  const [emailSearch, setEmailSearch] = useState("");
  const [ruleSearch, setRuleSearch] = useState("");
  const [activeSection, setActiveSection] = useState("email");

  const handleEmailChange = (event) => {
    setSelectedEmailGroup(event.target.value);
  };

  const handleRuleChange = (event) => {
    setSelectedRuleGroup(event.target.value);
  };

  const handleSave = (section) => {
    AlertManager.success(`${section} assigned.`, { contactSupport: false });
  };

  const renderSearchRow = (value, onChange, sectionLabel) => (
    <div className={classes.formRow}>
      <div className={classes.formField}>
        <label className={classes.label}>Search directory</label>
        <TextField
          fullWidth
          size="small"
          placeholder="Lookup user or distribution list"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
      </div>
      <div className={`${classes.formField} ${classes.formActionField}`}>
        <label className={classes.label}>&nbsp;</label>
        <Button
          variant="contained"
          size="small"
          color="primary"
          onClick={() => handleSave(sectionLabel)}
        >
          Assign
        </Button>
      </div>
    </div>
  );

  const renderEmailContent = () => (
    <>
      <h2 className={classes.logHeading}>Email intimation</h2>
      <div className={classes.formRow}>
        <div className={classes.formField}>
          <label className={classes.label}>Notification group</label>
          <Select
            fullWidth
            size="small"
            value={selectedEmailGroup}
            onChange={handleEmailChange}
          >
            {EMAIL_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </div>
      </div>
      {renderSearchRow(emailSearch, setEmailSearch, "Email intimation")}
    </>
  );

  const renderRulesContent = () => (
    <>
      <h2 className={classes.logHeading}>Rules configuration</h2>
      <div className={classes.formRow}>
        <div className={classes.formField}>
          <label className={classes.label}>Rule ownership</label>
          <Select
            fullWidth
            size="small"
            value={selectedRuleGroup}
            onChange={handleRuleChange}
          >
            {RULE_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </div>
      </div>
      {renderSearchRow(ruleSearch, setRuleSearch, "Rules configuration")}
    </>
  );

  return (
    <section className={classes.page}>
      <header className={classes.header}>
        <div>
          <h1>User assignment</h1>
          <p>Control who receives landed cost notifications and who owns the rules.</p>
        </div>
      </header>

      <div className={classes.layout}>
        <div className={classes.leftColumn}>
          {NAV_SECTIONS.map(({ key, title }) => (
            <Button
              key={key}
              size="small"
              variant={activeSection === key ? "contained" : "outlined"}
              className={classes.ruleButton}
              onClick={() => setActiveSection(key)}
            >
              {title}
            </Button>
          ))}
        </div>

        <div className={classes.rightColumn}>
          <section className={classes.formCard}>
            {activeSection === "email" ? renderEmailContent() : renderRulesContent()}
          </section>
        </div>
      </div>
    </section>
  );
};

export default UserAssignment;
